module.exports = __webpack_public_path__ + "static/media/logo_eodyne.4d838e5e.svg";